import {environment} from '../environments/environment';

export const navigation = [
  {
    text: 'Results Search',
    icon: `${environment.frontendUrl}/assets/icons/Results.svg`,
    roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'],
    items: [
      {
        text: 'Order Search',
        path: 'results/lab',
        roles: ['Superuser', 'Client Admin', 'Patient', 'Client Basic', 'Physician']
      },
      {
        text: 'Advanced Order Search',
        path: 'results/advanced-search',
        hiddenInMobile: true,
        roles: ['Superuser', 'Client Admin', 'Patient', 'Client Basic', 'Physician']
      }
    ]
  },
  {
    text: 'Requisition',
    icon: `${environment.frontendUrl}/assets/icons/Requisitions.svg`,
    roles: ['Superuser', 'Client Admin', 'Client Basic', 'Physician'],
    items: [
      {
        text: 'Requisition Search',
        path: 'requisitions/search',
        roles: ['Superuser', 'Client Admin', 'Client Basic', 'Physician']
      },
      {
        text: 'New Requisition',
        path: 'requisitions/create',
        roles: ['Superuser', 'Client Admin', 'Client Basic']
      },
    ],
  },
  {
    text: 'Result Entry',
    icon: `${environment.frontendUrl}/assets/icons/Requisitions.svg`,
    roles: ['Superuser', 'Client Admin', 'Client Basic'],
    hidden: true,
    path: 'result-entry',
  },
  {
    text: 'Standing Orders',
    icon: `${environment.frontendUrl}/assets/icons/Standing orders.svg`,
    path: 'standing-orders/search',
    roles: ['Superuser', 'Client Admin', 'Client Basic'],
  },
  {
    text: 'Users',
    path: 'system/users',
    icon: `${environment.frontendUrl}/assets/icons/user.svg`,
    roles: ['Superuser', 'Client Admin']
  },
  {
    text: 'Support',
    icon: `${environment.frontendUrl}/assets/icons/Support.svg`,
    roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'],
    items: [
      {
        text: 'Contact us',
        path: 'support/contact-us',
        roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician']
      },
      {
        text: 'Supply Request',
        path: 'support/supply-request',
        roles: ['Superuser', 'Client Admin', 'Client Basic']
      },
    ],
  },
];
